module.exports = __webpack_public_path__ + "static/media/grocery-product-8.38863c19.png";